//import { Component } from 'react'
import { todaysclue, todayshint } from '../../lib/words'

type Props = {
  isShowing: boolean
  isHint: boolean
  isClue: boolean
}

//const showtheclue = (value: boolean) => {}
export const lineLimit = 100
export let fillpadding: number = 0
export const Hint = ({ isShowing, isHint, isClue }: Props) => {
  const theclue = () => {
    if (isShowing && isHint) {
      fillpadding = (lineLimit - todayshint.length) / 2
      return 'Hint: '.concat(todayshint)
    }
    if (isShowing && isClue) {
      fillpadding = (lineLimit - todaysclue.length) / 2
      return 'Hint: '.concat(todaysclue)
    }
  }

  const classassign = () => {
    if (isShowing) {
      return 'xxshort:h-8 xxshort:w-8 xxshort:text-xxs xshort:w-10 xshort:h-10 flex short:h-12 h-14 items-center justify-center rounded mx-0.5 text-xs font-bold cursor-pointer select-none dark:text-white bg-slate-200 dark:bg-slate-600 hover:bg-slate-300 active:bg-slate-400'
    } else {
      return ''
    }
  }

  return (
    <div className="mb-1 flex justify-center">
      <span
        className={classassign()}
        style={{
          margin: isShowing ? '15px' : '',
          backgroundColor: isShowing ? '#26C35D' : '',
          width: '40%',
          fontSize: 'large',
        }}
      >
        {theclue()}
      </span>
    </div>
  )
}
